<template>
  <div class="setup-box">

    <div class="game-item" @click="goGamedetails(state.giftInfo.gid)">
      <img :src="state.giftInfo.card_image ? state.giftInfo.card_image : state.noimg" />
      <div class="game-info">
        <div class="div-mid">
          <h3 class="van-ellipsis">{{ state.giftInfo.name }}</h3>
          <p>{{ state.giftInfo.gamename }}</p>
        </div>
      </div>
    </div>

    <div class="mid-box">
      <div>
        <p v-if="state.giftInfo.status == '0'">
          剩余{{ state.giftInfo.remain_num }}个

          <!-- 剩余1000个 -->
        </p>
        <p v-else id="share-code">
          {{ state.giftInfo.code }}
          <!-- {{ state.giftInfo.code }} -->
        </p>
      </div>

      <van-button v-if="state.giftInfo.status == '0'" type="primary" size="mini" class="giftget" color="#12CEC7"
        @click="onReceive()">领取</van-button>

      <van-button v-else type="primary" size="mini" color="#12CEC7" class="copy" id="copy-btn"
        data-clipboard-action="copy" data-clipboard-target="#share-code"
        @click="copyWaybillNo('#copy-btn')">复制</van-button>
    </div>
    <div class="content">
      <div class="nr-box">
        <h3>礼包内容</h3>
        <p>{{ state.giftInfo.excerpt }}</p>
      </div>
      <div v-if="state.needvip" class="nr-box">
        <h3>领取条件</h3>
        <p>{{ state.giftInfo.needvip }}</p>
      </div>
      <div v-else-if="state.needcard" class="nr-box">
        <h3>领取条件</h3>
        <p>{{ state.giftInfo.needcard }}</p>
      </div>
      <div v-else class="nr-box">
        <h3>领取条件</h3>
        <p>{{ state.giftInfo.paymoney }}</p>
      </div>
      <div class="nr-box">
        <h3>使用方法</h3>
        <p>{{ state.giftInfo.card_context }}</p>
      </div>
      <div class="nr-box">
        <h3>兑换期限</h3>
        <p>{{ state.giftInfo.end_time }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import {
  reactive,
  nextTick,
  onMounted,
  onUnmounted,
  onActivated
} from "vue";
import {
  useRoute,
  useRouter
} from "vue-router";
import defaultimg1 from "@/assets/defaultimg/error2.png";
import {
  cardDetails_xh,
  getCode_xh,
} from "@/api/yzgame";
import {
  Toast
} from "vant";
import Clipboard from "clipboard";
import { getQueryString } from "@/utils/location";
import { get } from "vant/lib/utils";
import { handleCopy } from "../../../utils/tool";
export default {
  name: "gift-detail",
  setup() {
    const route = useRoute();
    const router = useRouter();
    const state = reactive({
      noimg: defaultimg1,
      giftInfo: {},
      needvip: "",
      needcard: route.query.needcard,
      status: route.query.status,
    });
    const onClickLeft = () => {
      router.back();
    };

    const goGamedetails = (id) => {
      router.push({
        path: "/gamedetails",
        query: {
          gid: id,
          edition: "0"
        }
      });
    };

    onUnmounted(() => {
      state.needvip = ""
      state.needcard = ""
    });
    onActivated(() => {
      if (route.query.needvip) {
        state.needvip = "领取礼包需" + route.query.needvip + "及以上会员可领取"
      } else {
        state.needvip = ""
      }
      if (route.query.needcard == 1) {
        state.needcard = "领取礼包需开通省钱卡或月卡"
      } else {
        state.needcard = ""
      }
      cardDetails_xh({
        cid: route.query.cid,
        uid: getQueryString("uid"),
        xiaohao: route.query.xiaohao,
      }).then((response) => {
        // console.log(response.data)
        if (response.data.a == 1) {
          state.giftInfo = response.data.c;
        } else {
          Toast(response.data.b);
        }
      });
    });

    // 复制礼包码
    const copyWaybillNo = (id) => {
      // let clipboard = new Clipboard(id);
      // nextTick(() => {
      //   clipboard.on("success", function () {
      //     Toast("礼包码已复制");
      //     clipboard.destroy();
      //   });
      //   clipboard.on("error", function () {
      //     Toast("您的浏览器不支持点击复制");
      //     clipboard.destroy();
      //   });
      // });
      handleCopy(id,state.giftInfo.code)
    };

    // 领取礼包
    const onReceive = () => {
      getCode_xh({
          cid: state.giftInfo.id,
          uid: getQueryString("uid"),
          xiaohao: route.query.xiaohao,
        }).then((response) => {
          // console.log('页面内领取的数据-------------', response)
          if (response.data.a == 1) {
            state.giftInfo.status = "1";
            state.giftInfo.code = response.data.c.code;
          }
          Toast(response.data.b);
        });
    };

    return {
      state,
      goGamedetails,
      onClickLeft,
      copyWaybillNo,
      onReceive
    };
  },
};
</script>
<style scoped="scoped">
:deep(.van-sticky) {
  padding-top: calc(32px + constant(safe-area-inset-top));
  /* 适配安全区域 iOS < 11.2 */
  padding-top: calc(32px + env(safe-area-inset-top));
  /* 适配安全区域 iOS >= 11.2 */
}

.left-nr {
  display: flex;
}

.left-nr img {
  width: 60px;
  height: 60px;
}

.setup-box {
  background-color: #f7f8fa;
  position: fixed;
  width: 100%;
  height: 100%;
  padding-top: 20px;
}

.nav-box {
  background-color: #FAFAFA;
}

.game-item {
  padding: 32px;
  display: flex;
  position: relative;
}

.game-item>img {
  width: 160px;
  height: 160px;
}

.game-item .game-info {
  flex: 1;
  width: 100%;
  overflow: hidden;
  padding-left: 20px;
}


.div-mid h3 {
  color: #333;
  font-size: 32px;
  margin-bottom: 16px;
}

.div-mid p {
  color: #666666;
  font-size: 24px;
}

.game-item .game-info p:nth-of-type(2) {
  font-size: 20px;
  color: #b0b0b0;
  margin-bottom: 5px;
  text-align: left;
}


.mid-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 32px;
  background: #fff;
  width: 686px;
  height: 72px;
  margin: 0 auto;
  border-radius: 10px;
}

.mid-box p {
  color: #12CEC7;
  font-size: 28px;
}

.mid-box:deep(.van-button) {
  height: 43px;
  width: 105px;
}

.content {
  padding: 32px;
}

.content .nr-box h3 {
  font-size: 28px;
  color: #333;
  margin-bottom: 24px;
}
.copy ,.giftget {
  border-radius: 10px;
}
.content .nr-box p {
  color: #707070;
  font-size: 24px;
  margin-bottom: 40px;
}</style>